module.exports = __webpack_public_path__ + "static/media/android.1e372113.svg";